module.exports = __webpack_public_path__ + "img/file.fd756222.svg";